<div class="d-flex justify-content-between" *ngFor="let item of wallets">
  <div class="container-fluid merchants pt-5 col-md-4 col-lg-4">
    <div class="card nc-card">
      <div class="card-body compliance-card-body card-padding">
        <div class="col-12 datetime d-flex">
          <div class="col-12 p-0 mt-3">
            <app-incoming-funds [wallet]="item"></app-incoming-funds>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid merchants pt-5 col-md-4 col-lg-4">
    <div style="flex-direction: column">
      <div class="card nc-card">
        <div class="card-body compliance-card-body card-padding">
          <div class="col-12 datetime d-flex">
            <div class="col-md-12 col-lg-12 p-0 mt-3">
              <span class="dashboardHeader">Current balance</span>
              <div class="value-align">
                <span class="text-label mb-0">Available balance</span>
                <div class="text-value2 text-left">
                  {{ item.currency === "USD" ? "$" : item.currency }}
                  {{ item.available_balance | number : "1.2-2" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid merchants pt-5 col-md-4 col-lg-4">
    <div style="flex-direction: column">
      <div class="card nc-card">
        <div class="card-body compliance-card-body card-padding">
          <div class="col-12 p-0 mt-3">
            <app-outgoing-funds [wallet]="item"></app-outgoing-funds>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
